import {
  Button,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Icon,
  Input,
  useToast,
} from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FaSave } from "react-icons/fa";
import { useApiError } from "../../../../common/errors/useApiError";
import { useSaveOrganization } from "../useOrganizationEditor";

interface FormValues {
  homePageUrl: string;
}

interface Props {
  currentValue: string;
}

export const ChangeHomePageUrl = ({ currentValue }: Props) => {
  const { saveOrganization, isSaving } = useSaveOrganization();
  const toast = useToast();
  const { t } = useTranslation();
  const displayer = useApiError();

  const {
    formState: { errors },
    register,
    handleSubmit,
    watch,
  } = useForm<FormValues>({
    defaultValues: {
      homePageUrl: currentValue,
    },
  });

  const newValue = watch("homePageUrl");

  const onSubmit = async (values: FormValues) => {
    try {
      await saveOrganization({ homePageUrl: { url: values.homePageUrl } });
      toast({
        title: t("Home page URL has been updated!"),
        status: "success",
      });
    } catch (e) {
      displayer.trigger(e);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl mt="15px" isInvalid={errors.homePageUrl !== undefined}>
          <FormLabel htmlFor={"homePageUrl"}>{t("Home page url")}</FormLabel>
          <Input
            id={"homePageUrl"}
            type="text"
            {...register("homePageUrl", {
              minLength: {
                value: 2,
                message: t("Must be at least 2 characters long."),
              },
            })}
          />
          <FormErrorMessage>{errors.homePageUrl && errors.homePageUrl.message}</FormErrorMessage>
          <FormHelperText>{t("Please provide a valid URL")}</FormHelperText>
        </FormControl>
        {currentValue.trim() !== newValue.trim() && (
          <Button
            mt="10px"
            leftIcon={<Icon as={FaSave} w="15px" h="15px" mt="-2px" />}
            variant={"solid"}
            colorScheme="teal"
            size={"sm"}
            isLoading={isSaving}
            type="submit"
          >
            {t("Save change")}
          </Button>
        )}
      </form>
    </>
  );
};
